import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import { AppState } from '@nxsys/store';
import { GetAgencyStatisticsResponse } from '@nxsys/types/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { showCurrencyByCountry } from '@nxsys/utils';
import { formatMoney } from '@nxsys/utils/number-helper';
import { toNumber } from 'lodash';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AgencyPaymentModal, {
  AgencyPaymentModalTypeEnum,
} from './components/AgencyPaymentModal';

type Props = {
  loading: boolean;
  data?: GetAgencyStatisticsResponse['data']['payment'];
  agencyId: string;
};

const AgencyPayment: React.FC<Props> = ({ loading, data, agencyId }) => {
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState<AgencyPaymentModalTypeEnum | null>(
    null,
  );

  const handleOpenModal = (type: AgencyPaymentModalTypeEnum) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  const items = [
    {
      title: formatMoney(
        toNumber(data?.totalPayment),
        showCurrencyByCountry(payrollCountry),
      ),
      description: 'Total Payments',
      icon: <Icons.IconMoneyReceive />,
      onClick: () => handleOpenModal(AgencyPaymentModalTypeEnum.TOTAL),
    },
    {
      title: formatMoney(
        toNumber(data?.invoiceOutstanding),
        showCurrencyByCountry(payrollCountry),
      ),
      description: 'Outstanding Invoices',
      icon: <Icons.IconMoneyBillPlus />,
      onClick: () => handleOpenModal(AgencyPaymentModalTypeEnum.OUTSTANDING),
    },
    {
      title: formatMoney(
        toNumber(data?.totalCredit),
        showCurrencyByCountry(payrollCountry),
      ),
      description: 'Credit Notes',
      icon: <Icons.IconMoneyBillMinus />,
      onClick: () => handleOpenModal(AgencyPaymentModalTypeEnum.CREDIT_NOTE),
    },
  ];

  return (
    <div className="OnHold">
      <AppCard className="p-[24px]" loading={loading}>
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard iconName="IconMoneyBill" title="Payments" />
        </div>
        <div className="grid grid-cols-3 gap-[16px] max-sm:grid-cols-1">
          {items.map((item) => (
            <div
              key={item.title}
              className="border border-[#CDDDD9] dashboard-hover-card bg-[#F9FBFA] rounded-[8px] p-[16px]"
              onClick={item.onClick}
            >
              <div className="flex items-center justify-between gap-x-[8px] mb-[18px]">
                <div className="bg-warning-100 rounded-[8px] p-[8px]">
                  {item.icon}
                </div>
                <Icons.IconArrowRight />
              </div>
              <div className="text-[22px] font-bold mb-[8px]">{item.title}</div>
              <div className="text-[14px] font-bold">{item.description}</div>
            </div>
          ))}
        </div>
      </AppCard>
      {modalType && (
        <AgencyPaymentModal
          isOpen={isOpenModal}
          toggle={() => setIsOpenModal(false)}
          type={modalType}
          agencyId={agencyId}
        />
      )}
    </div>
  );
};

export default AgencyPayment;
